// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li[data-v-3ad18b79],p[data-v-3ad18b79]{line-height:1.9rem;font-size:1.1rem;text-align:justify}", ""]);
// Exports
module.exports = exports;
